import { useEffect as e, useRef as t } from "react";
//#region src/lib/hooks/useInterval.ts
function n(n, r) {
	let i = t(null);
	e(() => {
		i.current = n;
	}, [n]), e(() => {
		function e() {
			i.current?.();
		}
		let t = setInterval(e, r);
		return () => clearInterval(t);
	}, [r]);
}
//#endregion
export { n as useInterval };
